import { ProFormText } from "@ant-design/pro-components";
import { Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import { addGroup, deleleGroup } from "@api";
import { PageEnum, TABLEPAI } from "@/enums/pageEnum";
import { getTimeToString } from "@/utils/toolt";
import { useTranslation } from "react-i18next";
import {
  PageTitle,
  HView,
  BasicTable,
  ComfirmButton,
  CustomModal,
} from "@/components";

export default function GroupPage() {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [refreshKey, setRefreshKey] = useState<number>();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const columns = [
    { title: t("groupName"), dataIndex: "name" },
    { title: t("members"), dataIndex: "memberCnt" },
    { title: t("permissions"), dataIndex: "permissionsCnt" },
    {
      title: t("editTime"),
      dataIndex: "updatedAt",
      renderText: (text: number) => <>{getTimeToString(text)}</>,
    },
    {
      title: t("action"),
      dataIndex: "action",
      renderText: (_: string, record: { id: string }) => {
        return (
          <>
            <HView
              name={t("view")}
              path={`${PageEnum.USRTGROUP}/detail/${record?.id}`}
              state={record}
            />
          </>
        );
      },
    },
  ];
  if (pathname !== PageEnum.USRTGROUP) {
    return <Outlet />;
  }
  return (
    <div className="p-4">
      <PageTitle title={t("group_management")} />
      <BasicTable
        columns={columns}
        key={refreshKey}
        filterTableFields={[
          { field: "name", label: t("groupName"), component: "text" },
        ]}
        isDefaultToolBar={false}
        headerTitle={() => t("groupList")}
        tableHeader={() => (
          <>
            <CustomModal
              title={t("addGroup")}
              request={addGroup}
              onClick={() => {
                setRefreshKey(Math.random());
              }}
            >
              <ProFormText
                name="name"
                label={t("groupName")}
                rules={[{ required: true }]}
              />
            </CustomModal>
            <ComfirmButton
              buttonCogfig={{
                disabled: !selectedRowKeys.length,
                className: "ml-4",
              }}
              onClick={() => {
                deleleGroup(selectedRowKeys as string[]).then(() => {
                  setRefreshKey(Math.random());
                });
              }}
              title={t("delete")}
            />
          </>
        )}
        requestUrl={TABLEPAI.GROUP}
        onChangeSelected={(rowkeys) => setSelectedRowKeys(rowkeys)}
      />
    </div>
  );
}
